import React, { useEffect, useState, Fragment } from 'react';
import { Clock3Icon } from 'lucide-react';
function formatTime(totalSeconds: number) {
  const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
  const minutes = Math.floor(totalSeconds % 3600 / 60).toString().padStart(2, '0');
  const seconds = (totalSeconds % 60).toString().padStart(2, '0');
  return {
    hours,
    minutes,
    seconds
  };
}
export function Countdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 53 * 60 + 6);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => value <= 0 ? 23 * 3600 + 59 * 60 + 59 : value - 1), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const time = formatTime(seconds);
  return <div className="border border-[#CDBCEB] bg-[#F5F0FC] p-4 text-center" data-id="element-26" data-mp="10c3d5gjo1fzd">
      <p className="flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.15em] text-[#6D28D9]" data-id="element-27" data-mp="15b698bho4bv7">
        <Clock3Icon className="h-4 w-4" aria-hidden="true" data-id="element-28" data-mp="y0esg83rqo4n" />
        Precio de lanzamiento cierra en
      </p>
      <div aria-label={`Quedan ${time.hours} horas, ${time.minutes} minutos y ${time.seconds} segundos`} className="mt-3 flex items-center justify-center gap-2 font-serif text-3xl font-semibold text-[#24212A]" data-id="element-29" data-mp="t1agxatdgeb5">
        {[time.hours, time.minutes, time.seconds].map((part, index) => <Fragment key={index} data-id="element-30" data-mp="f2uazm3c2ru2" data-mpi={index}>
            <span className="min-w-[52px] border border-[#DCD4E7] bg-[#FFFDFB] px-2 py-1" data-id="element-31" data-mp="f45cff9b3ni0">
              {part}
            </span>
            {index < 2 && <span className="text-[#6D28D9]" data-id="element-32" data-mp="o41w12gu9w67">:</span>}
          </Fragment>)}
      </div>
      <p className="mt-2 text-xs text-[#5E5968]" data-id="element-33" data-mp="k15i3p28uo8l">
        Después sube $30 USD. No vuelve.
      </p>
    </div>;
}